import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import useTextDtoValue from "@/utils/use-text-dto-value";

type ArticleItemReturnReasonProps = {
  returnReasonId: string;
};

export default function ArticleItemReturnReason({
  returnReasonId,
}: ArticleItemReturnReasonProps) {
  const { data: shop } = useCurrentShopSuspense();
  const reason = shop.reasons.find((reason) => reason.id === returnReasonId);
  const label = useTextDtoValue(reason?.values);
  return label;
}
